import React, { useRef, useEffect } from "react"
import ClientReportSprintSummary from "./ClientReportSprintSummary.controller"
import GeneralSprintProgress from "../Development/GeneralSprintProgress.controller"
import ClientSprintBudgetState from "../Development/ClientSprintBudgetState.controller"
import ClientSprintDetailedEstimation from "../Development/ClientSprintDetailedEstimation.controller"
import ClientSprintHorizonEstimation from "../Development/ClientSprintHorizonEstimation.controller"
import ClientReportTitle from "./ClientReportTitle.controller"
import ClientReportNotes from "./ClientReportNotes.controller.js"
import {
  CLIENT_SPRINT_CARD_MODES,
  CLIENT_SPRINT_CARD_SIZE_MODES,
} from "../../../../consts/modules/clientReport.consts"
import ClientBurnchart from "../Burnchart/ClientBurnchart.controller"
import { useSearchParams } from "react-router-dom"
import { fromBase64Url } from "../../../../utils/strings.utils"
import { UNIFIEDDATE_VALUES } from "../../../../consts/CompoundRangeDatePicker"
import usePresentationMode from "../../hooks/usePresentationMode.hook"
import { ThemeContext } from "../../../../contexts/ThemeContext.context"

const CLIENT_REPORT_DOWNLOAD_CONFIG = {
  TITLE: {
    component: ClientReportTitle,
  },
  SUMMARY: {
    component: ClientReportSprintSummary,
  },
  POINT_PROGRESS: {
    label: "Progreso del alcance",
    component: GeneralSprintProgress,
  },
  DETAILED_ESTIMATION: {
    label: "Estimación detallada",
    component: ClientSprintDetailedEstimation,
  },
  BURNCHART: {
    label: "Burnchart",
    component: ClientBurnchart,
  },
  HORIZON_ESTIMATION: {
    component: ClientSprintHorizonEstimation,
  },
  BUDGET_STATE: {
    label: "Estado del presupuesto",
    component: ClientSprintBudgetState,
  },
  NOTES: {
    label: "Notas del reporte",
    component: ClientReportNotes,
  },
}

const ClientReportPresentationMode = ({ refresh, triggerRefresh }) => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get("t")
  const periodParam = searchParams.get("p")
  const period =
    periodParam ? fromBase64Url(periodParam) : UNIFIEDDATE_VALUES.SPRINT

  const visibleMapParam = searchParams.get("v")

  const {
    reportData,
    visibleMap,
    loading: hookLoading,
  } = usePresentationMode({
    token,
    visibleMapParam,
  })

  const isVisible = (path) =>
    path.split("-").reduce((acc, key) => acc?.[key], visibleMap)

  const hasAnyVisibleChild = (configObj, parentKey) =>
    Object.keys(configObj).some((key) =>
      isVisible(parentKey ? `${parentKey}-${key}` : key)
    )

  const getLabelFromConfig = (path) => {
    return path
      .split("-")
      .reduce((acc, key) => acc?.[key], CLIENT_REPORT_DOWNLOAD_CONFIG)?.label
  }
  const chartRefs = useRef({})

  const renderReportComponents = (
    configObj,
    parentKey = "",
    originalObj,
    chartRefs
  ) =>
    Object.entries(configObj).flatMap(([key, config]) => {
      const compoundKey = parentKey ? `${parentKey}-${key}` : key
      if (config?.component && isVisible(compoundKey)) {
        const Component = config.component
        const parentVisibility =
          parentKey && isVisible(parentKey) ?
            Object.values(
              parentKey.split("-").reduce((acc, k) => acc?.[k], visibleMap)
            ).filter(Boolean)
          : []

        const isSingleInGroup = parentVisibility.length === 1

        const extraProps = {}
        if (config?.component) {
          const keyForRef = compoundKey
          chartRefs.current[keyForRef] =
            chartRefs.current[keyForRef] || React.createRef()
          extraProps.refChart = chartRefs.current[keyForRef]
          extraProps.chartRefs = chartRefs
        }

        return (
          <Component
            key={compoundKey}
            sprintData={reportData?.sprintData}
            selectedPeriod={reportData?.sprintData}
            clientId={reportData?.clientId}
            clientName={reportData?.clientName}
            clientLogo={reportData?.clientLogo}
            isPresentationMode={true}
            refresh={refresh}
            period={period}
            hookLoading={hookLoading}
            triggerRefresh={triggerRefresh}
            mode={CLIENT_SPRINT_CARD_MODES.VIEW_ONLY}
            sizeMode={
              isSingleInGroup ?
                CLIENT_SPRINT_CARD_SIZE_MODES.LONG
              : CLIENT_SPRINT_CARD_SIZE_MODES.COMPACT
            }
            visibleMap={visibleMap}
            getSectionLabel={getLabelFromConfig}
            hideButtons={true}
            hideResponsible={true}
            hideAverages={true}
            statusVisible={false}
            collapsible={true}
            {...extraProps}
          />
        )
      }

      if (typeof config === "object" && !config.component) {
        if (!hasAnyVisibleChild(config, compoundKey)) {
          return null
        }
        return (
          <div key={compoundKey} className="flex gap-3 flex-wrap">
            {renderReportComponents(
              config,
              compoundKey,
              originalObj,
              chartRefs
            )}
          </div>
        )
      }

      return []
    })

  const { changeTheme } = React.useContext(ThemeContext)

  useEffect(() => {
    changeTheme("light")
  }, [changeTheme])

  return (
    <div className="flex flex-column">
      <div id="reporte-cliente" className="w-full flex justify-content-center">
        <div className="reporte-cliente-tabs client-report-presentation-container flex flex-column gap-3 w-full pb-4">
          {reportData &&
            renderReportComponents(
              CLIENT_REPORT_DOWNLOAD_CONFIG,
              "",
              CLIENT_REPORT_DOWNLOAD_CONFIG,
              chartRefs
            )}
        </div>
      </div>
    </div>
  )
}

export default ClientReportPresentationMode
